  <p-dialog
  [(visible)]="display"
  [style]="{ width: '40vw' }"
  (onHide)="reloadDocumentDetail()"
  id="documentFileCheckinModal"
  [modal]="true"
>
  <ng-template pTemplate="header"> 
    <div style="font-size: 1.5rem">Check In</div>
    </ng-template>
  <app-label labelText={{fileCheckInLabelText}}>
  </app-label>

  <div class="grid mt-2 fileCheckInPlaceholder" *ngIf="isNoTemplate">
    <div class="col-6">
    <bpt-file-upload
    [disabled]="disableFileUploader"
      [uploadFiles]="uploadSucceeds"
      [deleteFile]="deleteFile"
      [maxSize]="maxFileSize"
      [fileNames]="savedFiles"
      [fileTypes]="''"
      [fileLimit]="maxFileLimit"
    ></bpt-file-upload>
    </div>
  <div class="col-6 mt-3 text-primary">
    <div>
      <div class="grid">
        <div class="col max-w-2rem" *ngIf="isUpload">
          <em
            class="blue-color cursor-pointer"

          >
          <app-file-icon fileType="{{fileType}}"></app-file-icon>
        </em> 
        </div>
        <div class="col">
          <app-read-only readonlyText="{{ fileName }}"></app-read-only>
        </div>
      </div>
    </div>
  </div>
</div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
    label="Check In"
    type="submit"
    id="checkInFile"
    class="align-right checkInButton"
    [disabled] = "disableCheckInButton"
    (debounceClick)="checkInFileForDocument($event)"
  >
  </p-button>
    <button
    appPreventDoubleClick
    pButton
    pRipple
    label="Cancel"
    type="submit"
    class="p-button-outlined"
    id="cancelFileCheckIn"
    iconPos="right"
    (debounceClick)="reloadDocumentDetail()"
  ></button>
   
  </ng-template>
</p-dialog>
